import { FC } from 'react';
import './styles.scss';

import classNames from 'classnames';

interface Props {
  color?: string;
  className?: string;
}

const Divider: FC<Props> = ({ color, ...props }) => (
  <hr className={classNames('divider', { [`bg-${color}`]: color })} {...props} />
);

export default Divider;
